module.exports = __webpack_public_path__ + "img/btn-personaliza.6ab7ff79.png";